import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh/index.js";
import en from "./en/index.js";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en", // 优先读本地存储
  legacy: true, // 关键：保证$t响应式
  messages: {
    zh,
    en,
  },
});

export default i18n;
